module.exports = __webpack_public_path__ + "static/media/CA.5d08ccab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/CA.svg
// module id = 2124
// module chunks = 7